import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import { Col, Row } from "react-bootstrap";
import CtaButton from "../Interface/CtaButton";

function TvaModal({ open, setOpen, callback }) {
  const [customTva, setCustomTva] = useState("");
  const [tvaError, setTvaError] = useState(false);

  const handleModalClosure = () => {
    setCustomTva("");
    setTvaError(false);
    setOpen(false);
  };

  const handleModalSubmission = () => {
    const response = callback(customTva);
    if (response) {
      handleModalClosure();
    }
  };

  const handleTvaSubmit = e => {
    if (e.key === "Enter") {
      if (customTva.length > 0) handleModalSubmission();
      else setTvaError(true);
    }
  };

  return (
    <Modal closeIcon={<></>} open={open} onClose={handleModalClosure}>
      <Row>
        <Col xs={12}>
          <p>Appliquer une TVA personnalisée...</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <label>TVA</label>
          <input
            name="tva"
            type="text"
            className={`form-control ${tvaError ? "has-error" : ""}`}
            onChange={({ target }) => setCustomTva(target.value)}
            onKeyUp={e => handleTvaSubmit(e)}
            value={customTva}
          />
          <span className={`invalid-feedback ${tvaError ? "show" : ""}`}>
            La TVA doit être un nombre valide.
          </span>
        </Col>
      </Row>
      <br />
      <Row>
        <Col xs={12}>
          <CtaButton action={handleTvaSubmit} text="Appliquer" />
          <a
            className="btn btn-default  float-end"
            onClick={handleModalClosure}
          >
            Annuler
          </a>
        </Col>
      </Row>
    </Modal>
  );
}

export default TvaModal;
